import { render, staticRenderFns } from "./SysLogList.vue?vue&type=template&id=37a317c0"
import script from "./SysLogList.vue?vue&type=script&lang=js"
export * from "./SysLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports